export default "/_next/static/images/customer-service-1b54209300447d01401a74bf64ed9592.svg";